import posthog from 'posthog-js'

export const usePostHog = () => {
  const apiKey = import.meta.env.VITE_POSTHOG_PUBLIC_KEY
  const posthogEnabled = Boolean(apiKey)

  // No project key configured yet (e.g. before the PostHog project is
  // provisioned, or a local build without the Netlify env var) -> no-op.
  if (posthogEnabled) {
    posthog.init(apiKey, {
      api_host: 'https://us.i.posthog.com',
      loaded: (ph) => {
        // moderation-admin ships a single build across dev/staging/prod and
        // bakes VITE_ENVIRONMENT=development, so environment is distinguished by
        // hostname at runtime (see HOSTNAME_API_TARGETS in services/api.ts), not
        // by the env var. Moderation is an internal staff tool, so session replay
        // stays on in every deployed environment; only opt out on local dev to
        // avoid noise.
        const host = window.location.hostname
        if (host === 'localhost' || host === '127.0.0.1') {
          ph.opt_out_capturing()
          ph.set_config({ disable_session_recording: true })
        }
      },
    })
  }

  return {
    posthog,
    posthogEnabled,
  }
}
